import { AssetSummaryState } from './asset-summary-state';

export const initialState: AssetSummaryState = {
  'imcc-assets': { count: 0 },
  'imcc-publications': { count: 0 },
  'imcc-graphic-symbols': { count: 0 },
  'imcc-store-communications': { count: 0 },
};
